export default "<!--header-->\r\n<app-header></app-header>\r\n<router-outlet></router-outlet>\r\n<!-- footer -->\r\n<app-footer></app-footer>\r\n"